export const leaseAndRentWordReplacer = text => {
  const map = {
    lease: 'housing agreement',
    rent: 'housing fee',
  }

  return text.replace(/\b(lease|rent)\b/gi, match => {
    const replacement = map[match.toLowerCase()]

    if (match === match.toUpperCase()) {
      return replacement.toUpperCase() // ALL CAPS
    } else if (match[0] === match[0].toUpperCase()) {
      return replacement[0].toUpperCase() + replacement.slice(1) // Capitalized
    }

    return replacement // lowercase
  })
}
